export class FailedToRefreshPermissionsError {

};
